/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FactorTaxonomy } from './factorTaxonomy';
import { FactorType } from './factorType';


/**
 * Factor taxonomy versions configured by factor type
 */
import { ValidateUtils } from 'app/shared/utils';

export class FactorTaxonomyConfiguration { 
    factorType?: FactorType;
    /**
     * Factor taxonomy versions configured for factor type
     */
    readonly factorTaxonomies?: Array<FactorTaxonomy>;

    constructor(item?: Partial<FactorTaxonomyConfiguration>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            factorType: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorType : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            factorTaxonomies: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorTaxonomies : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: FactorTaxonomyConfiguration.isValid,
        };
    }

    static isValid(obj: FactorTaxonomyConfiguration): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = FactorTaxonomyConfiguration.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.factorType.isValid(item);
            result = result && validationObject.factorTaxonomies.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

